import { userRoles as ur } from "../../assets/const/userRole";
import Account from "../pages/setting/Account";
import Billing from "../pages/setting/Billing";
import BillingHistory from "../pages/setting/BillingHistory";
import Company from "../pages/setting/Company";
import Profile from "../pages/setting/Profile";
import Users from "../pages/setting/Users";

export const settingRoutes=[
    
    {
        path: '/settings/company',
        name:"Company",
        element: <Company/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_BILLING,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_INTERMEDIARY_REPORT,ur.ROLE_USER]
    },
    {
        path: '/settings/users',
        name:"Users",
        element: <Users/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_USER]
    },
    {
        path: '/settings/billing',
        name:"Billing",
        element: <Billing/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_BILLING,ur.ROLE_USER]
    },

    {
        path: '/settings/billing-history',
        name:"Billing-history",
        element: <BillingHistory/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_BILLING,ur.ROLE_USER]
    },
    
    {
        path: '/settings/profile',
        name:"Profile",
        element: <Profile/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_INTERMEDIARY_REPORT,ur.ROLE_INTERMEDIARY_BILLING,ur.ROLE_USER]
    },
]